import request from '@/config';

import { CtCategoryBase, CategoryDeleteDto, CategorySearch, CategoryBaeSearch, CategoryValidBase } from './category.dto';

enum Apis {
	ParentList = `/api/ctcategory/getcategoryparentlist`,
	GetCatValidList = `/api/categoryvalid/getcategoryvalid`,
	SetCatValid = `/api/categoryvalid/setcategoryvalid`,
	GetCatValid = `/api/categoryvalid/getcatvalidlist`,
	CategoryCache = `/api/ctcategory/getcategorylistbycache`,
}

/* 获取分类列表(缓存) */
export const GetCtCategoryCacheApi = (): Promise<IResponse> => request.post({ url: Apis.CategoryCache, data: {} });

/* 分类创建 */
export const CategoryCreateApi = (createDto: CtCategoryBase): Promise<IResponse> => {
	return request.post({ url: '/api/ctcategory/creation', data: createDto });
};

/* 分类创建 */
export const CategoryModifyApi = (createDto: CtCategoryBase): Promise<IResponse> => {
	return request.post({ url: '/api/ctcategory/modify', data: createDto });
};

/* 分类删除 */
export const CategoryDelApi = (createDto: CategoryDeleteDto): Promise<IResponse> => {
	return request.post({ url: '/api/ctcategory/deletion', data: createDto });
};

/* 获取分类明细 */
export const GetCategoryApi = (rowId: string): Promise<IResponse> => {
	return request.post({ url: '/api/ctcategory/getdetail', data: { id: rowId } });
};

/* 获取分类列表 */
export const GetCategoryListApi = (search: CategorySearch): Promise<IResponse> => {
	return request.post({ url: '/api/ctcategory/getcategorylist', data: search });
};

const GetCategoryTreeApi = (search: CategoryBaeSearch): Promise<IResponse> => {
	return request.post({ url: '/api/ctcategory/gettreelist', data: search });
};

const GetParentListApi = (): Promise<IResponse> => {
	return request.post({ url: Apis.ParentList, data: {} });
};

/* 设置合同分类验证 */
const SetCatValidApi = (input: CategoryValidBase): Promise<IResponse> => {
	return request.post({ url: Apis.SetCatValid, data: input });
};

/* 获取合同分类验证 */
const GetCatValidListApi = (catId: string): Promise<IResponse> => {
	return request.post({ url: Apis.GetCatValidList, data: { category_id: catId } });
};

/* 获取配置列表 */
const GetCatValidInfoApi = (catId: string, mtId: string): Promise<IResponse> => {
	return request.post({ url: Apis.GetCatValid, data: { category_id: catId, mainstay_id: mtId } });
};

export { GetCategoryTreeApi, GetParentListApi, GetCatValidListApi, SetCatValidApi, GetCatValidInfoApi };
